export type MovieCast = {
  name: string;
  role: string;
  avatar: string;
};

export type Movie = {
  id: string;
  title: string;
  originalTitle: string;
  year: number;
  genres: string[];
  region: string;
  duration: number;
  rating: number;
  director: string;
  cast: MovieCast[];
  synopsis: string;
  plot: string;
  tags: string[];
  poster: string;
  backdrop?: string;
};

const av = [
  "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20male%20actor%2C%20short%20dark%20hair%2C%20neutral%20charcoal%20studio%20background%2C%20soft%20dramatic%20side%20lighting%2C%20serious%20expressive%20face%2C%20elegant%20film%20promo%20headshot%2C%20warm%20amber%20tone&width=300&height=300&seq=actor-01-sq&orientation=squarish",
  "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20female%20actress%2C%20long%20wavy%20hair%2C%20neutral%20charcoal%20studio%20background%2C%20soft%20dramatic%20side%20lighting%2C%20calm%20expressive%20face%2C%20elegant%20film%20promo%20headshot%2C%20warm%20amber%20tone&width=300&height=300&seq=actor-02-sq&orientation=squarish",
  "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20male%20actor%2C%20tidy%20beard%2C%20neutral%20charcoal%20studio%20background%2C%20soft%20dramatic%20side%20lighting%2C%20thoughtful%20gaze%2C%20elegant%20film%20promo%20headshot%2C%20warm%20amber%20tone&width=300&height=300&seq=actor-03-sq&orientation=squarish",
  "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20female%20actress%2C%20elegant%20updo%20hair%2C%20neutral%20charcoal%20studio%20background%2C%20soft%20dramatic%20side%20lighting%2C%20confident%20expression%2C%20elegant%20film%20promo%20headshot%2C%20warm%20amber%20tone&width=300&height=300&seq=actor-04-sq&orientation=squarish",
  "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20male%20actor%2C%20silver%20grey%20hair%2C%20neutral%20charcoal%20studio%20background%2C%20soft%20dramatic%20side%20lighting%2C%20mature%20composed%20face%2C%20elegant%20film%20promo%20headshot%2C%20warm%20amber%20tone&width=300&height=300&seq=actor-05-sq&orientation=squarish",
  "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20young%20female%20actress%2C%20straight%20black%20hair%2C%20neutral%20charcoal%20studio%20background%2C%20soft%20dramatic%20side%20lighting%2C%20soft%20melancholic%20expression%2C%20elegant%20film%20promo%20headshot%2C%20warm%20amber%20tone&width=300&height=300&seq=actor-06-sq&orientation=squarish",
  "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20male%20actor%2C%20curly%20hair%2C%20neutral%20charcoal%20studio%20background%2C%20soft%20dramatic%20side%20lighting%2C%20intense%20stare%2C%20elegant%20film%20promo%20headshot%2C%20warm%20amber%20tone&width=300&height=300&seq=actor-07-sq&orientation=squarish",
  "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20female%20actress%2C%20short%20bob%20hair%2C%20neutral%20charcoal%20studio%20background%2C%20soft%20dramatic%20side%20lighting%2C%20sharp%20clever%20expression%2C%20elegant%20film%20promo%20headshot%2C%20warm%20amber%20tone&width=300&height=300&seq=actor-08-sq&orientation=squarish",
  "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20male%20actor%2C%20swept%20back%20hair%2C%20neutral%20charcoal%20studio%20background%2C%20soft%20dramatic%20side%20lighting%2C%20calm%20gentle%20expression%2C%20elegant%20film%20promo%20headshot%2C%20warm%20amber%20tone&width=300&height=300&seq=actor-09-sq&orientation=squarish",
  "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20female%20actress%2C%20half%20up%20hair%2C%20neutral%20charcoal%20studio%20background%2C%20soft%20dramatic%20side%20lighting%2C%20warm%20fragile%20expression%2C%20elegant%20film%20promo%20headshot%2C%20warm%20amber%20tone&width=300&height=300&seq=actor-10-sq&orientation=squarish",
  "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20male%20actor%2C%20grey%20eyes%2C%20neutral%20charcoal%20studio%20background%2C%20soft%20dramatic%20side%20lighting%2C%20cold%20reserved%20expression%2C%20elegant%20film%20promo%20headshot%2C%20warm%20amber%20tone&width=300&height=300&seq=actor-11-sq&orientation=squarish",
  "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20female%20actress%2C%20loose%20waves%2C%20neutral%20charcoal%20studio%20background%2C%20soft%20dramatic%20side%20lighting%2C%20sly%20knowing%20smile%2C%20elegant%20film%20promo%20headshot%2C%20warm%20amber%20tone&width=300&height=300&seq=actor-12-sq&orientation=squarish",
];

export const movies: Movie[] = [
  {
    id: "1",
    title: "交换朋友的妻子",
    originalTitle: "Swapping Friends' Wives",
    year: 2018,
    genres: ["剧情", "爱情", "悬疑"],
    region: "美国",
    duration: 118,
    rating: 8.1,
    director: "马克·罗兰",
    cast: [
      { name: "艾米莉·卡特", role: "饰 苏珊", avatar: av[1] },
      { name: "大卫·威尔逊", role: "饰 迈克尔", avatar: av[0] },
      { name: "索菲亚·罗曼", role: "饰 海伦", avatar: av[3] },
      { name: "詹姆斯·里德", role: "饰 大卫", avatar: av[2] },
    ],
    synopsis: "两对多年好友夫妻在一次周末聚会上提出大胆的情感实验，信任与占有欲随之崩塌。",
    plot:
      "相识多年的两对好友夫妻，在一个看似寻常的周末聚会上，被一位心理学者提出的观点点燃了一个大胆的念头——交换伴侣，用一个月的时间重新体验爱情的陌生感。起初，四人把这当作一场理性的实验，试图用坦诚谈话化解一切不适。然而随着日常琐碎与旧日情愫不断浮现，隐藏的猜忌、被忽视的欲望和无法说出口的遗憾逐渐露出水面。当实验接近尾声，四个人的婚姻与友情都站到了崩溃的边缘。影片以冷峻克制的镜头语言，探讨了信任、占有与爱之间那条被反复踩踏的边界。",
    tags: ["婚姻", "信任", "情感实验"],
    poster:
      "https://readdy.ai/api/search-image?query=a%20tense%20double%20portrait%20of%20two%20couples%20in%20a%20dim%20living%20room%20with%20warm%20lamplight%2C%20cinematic%20film%20poster%20art%2C%20moody%20deep%20red%20and%20amber%20color%20palette%2C%20dramatic%20chiaroscuro%20lighting%2C%20subtle%20film%20grain%2C%20elegant%20negative%20space%20for%20title%2C%20emotional%20relationship%20drama%20mood%2C%20highly%20detailed%20vertical%20composition&width=600&height=900&seq=film-01-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20moody%20dim%20living%20room%20at%20night%20where%20two%20couples%20converse%20in%20warm%20lamplight%2C%20deep%20red%20and%20amber%20tones%2C%20cinematic%20drama%20still%2C%20atmospheric%20shadows%2C%20high%20detail&width=1600&height=900&seq=film-01-backdrop&orientation=landscape",
  },
  {
    id: "2",
    title: "相邻的窗",
    originalTitle: "The Neighboring Windows",
    year: 2015,
    genres: ["剧情", "爱情"],
    region: "法国",
    duration: 104,
    rating: 7.6,
    director: "克莱尔·德邦",
    cast: [
      { name: "露西·莫罗", role: "饰 安娜", avatar: av[2] },
      { name: "安托万·贝尔", role: "饰 皮埃尔", avatar: av[4] },
      { name: "玛戈·肖", role: "饰 克拉拉", avatar: av[11] },
    ],
    synopsis: "两扇正对的窗户，两段有裂痕的婚姻，在一场社区纠纷后悄然靠近。",
    plot:
      "住在同一栋公寓正对面的安娜与皮埃尔，各自经营着看似平静却暗流涌动的婚姻。一次因为漏水引发的社区纠纷，让两个家庭不得不频繁往来。透过各自的窗，他们先看见了对方生活里的疲惫，又逐渐看见了彼此的孤独。当理解跨越了距离，善意也开始变得危险。",
    tags: ["邻里", "孤独", "克制"],
    poster:
      "https://readdy.ai/api/search-image?query=a%20lone%20woman%20gazing%20out%20of%20an%20apartment%20window%20at%20night%2C%20cinematic%20film%20poster%20art%2C%20moody%20deep%20red%20and%20amber%20color%20palette%2C%20dramatic%20chiaroscuro%20lighting%2C%20subtle%20film%20grain%2C%20elegant%20negative%20space%20for%20title%2C%20emotional%20relationship%20drama%20mood%2C%20highly%20detailed%20vertical%20composition&width=600&height=900&seq=film-02-poster&orientation=portrait",
  },
  {
    id: "3",
    title: "第三个人的房间",
    originalTitle: "The Third Room",
    year: 2019,
    genres: ["悬疑", "剧情", "心理"],
    region: "韩国",
    duration: 122,
    rating: 7.9,
    director: "朴承佑",
    cast: [
      { name: "韩智秀", role: "饰 允儿", avatar: av[5] },
      { name: "金泰成", role: "饰 民俊", avatar: av[6] },
      { name: "李恩珠", role: "饰 世拉", avatar: av[7] },
    ],
    synopsis: "一间始终锁着的次卧，藏着一个家庭最不愿被提起的秘密。",
    plot:
      "婚后搬进老宅的允儿发现，丈夫家中始终有一间上锁的次卧，钥匙被婆婆随身收着。好奇心与不安交织，她开始留意家里每一次反常的沉默。当她终于推开那扇门，看到的不是鬼魂，而是一段被整个家庭合谋遗忘的往事。",
    tags: ["秘密", "家庭", "回忆"],
    poster:
      "https://readdy.ai/api/search-image?query=a%20silhouette%20of%20a%20stranger%20in%20a%20doorway%20of%20a%20warm%20lit%20room%2C%20cinematic%20film%20poster%20art%2C%20moody%20deep%20red%20and%20amber%20color%20palette%2C%20dramatic%20chiaroscuro%20lighting%2C%20subtle%20film%20grain%2C%20elegant%20negative%20space%20for%20title%2C%20emotional%20relationship%20drama%20mood%2C%20highly%20detailed%20vertical%20composition&width=600&height=900&seq=film-03-poster&orientation=portrait",
  },
  {
    id: "4",
    title: "沉默的晚餐",
    originalTitle: "The Silent Dinner",
    year: 2012,
    genres: ["剧情", "家庭"],
    region: "意大利",
    duration: 98,
    rating: 7.3,
    director: "卢卡·费拉里",
    cast: [
      { name: "乔治·孔蒂", role: "饰 马可", avatar: av[8] },
      { name: "艾莲娜·罗西", role: "饰 薇拉", avatar: av[9] },
      { name: "尼科·布鲁诺", role: "饰 托马斯", avatar: av[10] },
    ],
    synopsis: "一顿筹备了三个月的家庭晚餐，却让每一个人的沉默说出了最多的话。",
    plot:
      "母亲薇拉为一家人准备了久违的团圆晚餐，桌上摆满了每个人小时候最爱吃的菜。可当所有人坐定，谈话却一次次陷入死寂。那些没说出口的道歉、隐瞒和失望，在刀叉的碰撞声里被无限放大。",
    tags: ["家庭", "沉默", "和解"],
    poster:
      "https://readdy.ai/api/search-image?query=a%20couple%20sitting%20silently%20across%20a%20long%20dinner%20table%2C%20cinematic%20film%20poster%20art%2C%20moody%20deep%20red%20and%20amber%20color%20palette%2C%20dramatic%20chiaroscuro%20lighting%2C%20subtle%20film%20grain%2C%20elegant%20negative%20space%20for%20title%2C%20emotional%20relationship%20drama%20mood%2C%20highly%20detailed%20vertical%20composition&width=600&height=900&seq=film-04-poster&orientation=portrait",
  },
  {
    id: "5",
    title: "双面婚姻",
    originalTitle: "Double Face of Marriage",
    year: 2021,
    genres: ["悬疑", "剧情"],
    region: "英国",
    duration: 110,
    rating: 8.0,
    director: "艾玛·格雷",
    cast: [
      { name: "奥利维亚·哈特", role: "饰 凯特", avatar: av[3] },
      { name: "亨利·邦德", role: "饰 理查德", avatar: av[2] },
      { name: "苏菲·唐", role: "饰 朱莉", avatar: av[7] },
    ],
    synopsis: "一个丈夫，两种截然不同的人生，妻子必须在真相与安稳之间做出选择。",
    plot:
      "凯特一直以为自己拥有一段令人羡慕的婚姻，直到她在丈夫的旧行李箱里发现了一整套陌生的证件。追查之下，她逐渐拼凑出丈夫隐藏多年的另一重身份。当两个世界开始重叠，她必须决定，是揭穿真相，还是继续守护这份安稳。",
    tags: ["身份", "谎言", "抉择"],
    poster:
      "https://readdy.ai/api/search-image?query=a%20woman%20reflected%20in%20two%20opposite%20mirrors%2C%20cinematic%20film%20poster%20art%2C%20moody%20deep%20red%20and%20amber%20color%20palette%2C%20dramatic%20chiaroscuro%20lighting%2C%20subtle%20film%20grain%2C%20elegant%20negative%20space%20for%20title%2C%20emotional%20relationship%20drama%20mood%2C%20highly%20detailed%20vertical%20composition&width=600&height=900&seq=film-05-poster&orientation=portrait",
  },
  {
    id: "6",
    title: "我们之间的秘密",
    originalTitle: "The Secret Between Us",
    year: 2017,
    genres: ["爱情", "剧情"],
    region: "日本",
    duration: 106,
    rating: 7.5,
    director: "中村知也",
    cast: [
      { name: "小林遥", role: "饰 美咲", avatar: av[6] },
      { name: "高桥凉介", role: "饰 健太", avatar: av[9] },
      { name: "佐藤由纪", role: "饰 玲奈", avatar: av[11] },
    ],
    synopsis: "一段从大学延续至今的友情，因为一个无人知晓的约定而变得微妙。",
    plot:
      "美咲与健太是大学时代的好友，多年来始终保持着一份说不清道不明的默契。当健太即将与别人订婚，两人之间那个从没被说破的秘密终于到了必须面对的时刻。有些心意，一旦说出口，就再也回不到从前。",
    tags: ["友情", "暗恋", "遗憾"],
    poster:
      "https://readdy.ai/api/search-image?query=two%20hands%20almost%20touching%20over%20a%20coffee%20table%2C%20cinematic%20film%20poster%20art%2C%20moody%20deep%20red%20and%20amber%20color%20palette%2C%20dramatic%20chiaroscuro%20lighting%2C%20subtle%20film%20grain%2C%20elegant%20negative%20space%20for%20title%2C%20emotional%20relationship%20drama%20mood%2C%20highly%20detailed%20vertical%20composition&width=600&height=900&seq=film-06-poster&orientation=portrait",
  },
  {
    id: "7",
    title: "失踪的妻子",
    originalTitle: "The Missing Wife",
    year: 2020,
    genres: ["悬疑", "惊悚"],
    region: "西班牙",
    duration: 115,
    rating: 7.8,
    director: "卡洛斯·梅纳",
    cast: [
      { name: "伊莎贝尔·诺", role: "饰 卡门", avatar: av[2] },
      { name: "哈维尔·奥尔特加", role: "饰 劳尔", avatar: av[4] },
      { name: "玛尔塔·桑斯", role: "饰 露西亚", avatar: av[5] },
    ],
    synopsis: "妻子在一个普通的清晨消失，留下的所有线索都指向丈夫自己。",
    plot:
      "卡门在一个平平无奇的清晨从家中消失，只留下一件挂好的外套和一杯还温着的咖啡。随着警方调查深入，所有证据都在微妙地指向她的丈夫劳尔。当真相一层层剥开，人们才发现，失踪或许只是一场更大谎言的开端。",
    tags: ["失踪", "反转", "真相"],
    poster:
      "https://readdy.ai/api/search-image?query=an%20empty%20chair%20and%20a%20single%20coat%20in%20a%20hallway%2C%20cinematic%20film%20poster%20art%2C%20moody%20deep%20red%20and%20amber%20color%20palette%2C%20dramatic%20chiaroscuro%20lighting%2C%20subtle%20film%20grain%2C%20elegant%20negative%20space%20for%20title%2C%20emotional%20relationship%20drama%20mood%2C%20highly%20detailed%20vertical%20composition&width=600&height=900&seq=film-07-poster&orientation=portrait",
  },
  {
    id: "8",
    title: "谎言的距离",
    originalTitle: "The Distance of Lies",
    year: 2014,
    genres: ["剧情", "爱情"],
    region: "中国大陆",
    duration: 101,
    rating: 7.1,
    director: "沈亦舟",
    cast: [
      { name: "林之遥", role: "饰 苏念", avatar: av[9] },
      { name: "陆沉", role: "饰 江野", avatar: av[8] },
      { name: "徐清", role: "饰 陈屿", avatar: av[0] },
    ],
    synopsis: "一对分隔两地的恋人，用无数个善意的谎言维系着摇摇欲坠的感情。",
    plot:
      "苏念与江野相恋五年，却因为工作长期分隔两地。为了不让对方担心，两人都习惯了报喜不报忧，用一个又一个善意的谎言填满电话两端的空白。直到某一天，谎言再也无法自圆其说，他们才看清彼此之间真正拉开的距离。",
    tags: ["异地", "谎言", "感情"],
    poster:
      "https://readdy.ai/api/search-image?query=a%20couple%20a%20few%20inches%20apart%20on%20a%20rainy%20street%2C%20cinematic%20film%20poster%20art%2C%20moody%20deep%20red%20and%20amber%20color%20palette%2C%20dramatic%20chiaroscuro%20lighting%2C%20subtle%20film%20grain%2C%20elegant%20negative%20space%20for%20title%2C%20emotional%20relationship%20drama%20mood%2C%20highly%20detailed%20vertical%20composition&width=600&height=900&seq=film-08-poster&orientation=portrait",
  },
  {
    id: "9",
    title: "一夜之间",
    originalTitle: "Overnight",
    year: 2016,
    genres: ["剧情", "惊悚"],
    region: "美国",
    duration: 96,
    rating: 7.2,
    director: "瑞恩·科尔",
    cast: [
      { name: "娜塔莉·格林", role: "饰 艾拉", avatar: av[3] },
      { name: "彼得·霍尔", role: "饰 肖恩", avatar: av[10] },
      { name: "黛安娜·李", role: "饰 米娅", avatar: av[7] },
    ],
    synopsis: "一场本不该发生的相遇，让三个人的命运在一夜之间彻底改写。",
    plot:
      "出差的肖恩在一家陌生的酒店里遇到了自称认识他妻子的女人。她带来了一个令人不安的消息，也带来了一个选择。一夜之后，肖恩才发现，自己已经走进了别人精心布置的局面之中。",
    tags: ["酒店", "陌生人", "命运"],
    poster:
      "https://readdy.ai/api/search-image?query=a%20hotel%20room%20door%20ajar%20with%20warm%20light%20spilling%20out%2C%20cinematic%20film%20poster%20art%2C%20moody%20deep%20red%20and%20amber%20color%20palette%2C%20dramatic%20chiaroscuro%20lighting%2C%20subtle%20film%20grain%2C%20elegant%20negative%20space%20for%20title%2C%20emotional%20relationship%20drama%20mood%2C%20highly%20detailed%20vertical%20composition&width=600&height=900&seq=film-09-poster&orientation=portrait",
  },
  {
    id: "10",
    title: "破碎的承诺",
    originalTitle: "Broken Promises",
    year: 2011,
    genres: ["剧情", "家庭"],
    region: "德国",
    duration: 108,
    rating: 7.0,
    director: "汉娜·克劳斯",
    cast: [
      { name: "莉娜·冯", role: "饰 格蕾塔", avatar: av[5] },
      { name: "托马斯·韦伯", role: "饰 卡尔", avatar: av[8] },
      { name: "安娜·舒尔茨", role: "饰 艾玛", avatar: av[11] },
    ],
    synopsis: "父亲临终前的一句承诺，成为女儿余生都在寻找的答案。",
    plot:
      "格蕾塔在父亲去世后，发现他留下了一句承诺和一堆未解的旧账。她循着零碎的线索走访父亲的老朋友，试图还原一个她从未真正了解过的父亲。每一次追问，都让承诺的轮廓更清晰，也让伤口更疼。",
    tags: ["父女", "承诺", "追寻"],
    poster:
      "https://readdy.ai/api/search-image?query=a%20broken%20picture%20frame%20on%20a%20wooden%20floor%2C%20cinematic%20film%20poster%20art%2C%20moody%20deep%20red%20and%20amber%20color%20palette%2C%20dramatic%20chiaroscuro%20lighting%2C%20subtle%20film%20grain%2C%20elegant%20negative%20space%20for%20title%2C%20emotional%20relationship%20drama%20mood%2C%20highly%20detailed%20vertical%20composition&width=600&height=900&seq=film-10-poster&orientation=portrait",
  },
  {
    id: "11",
    title: "无声的对峙",
    originalTitle: "Silent Standoff",
    year: 2013,
    genres: ["剧情", "悬疑"],
    region: "中国香港",
    duration: 112,
    rating: 7.4,
    director: "陈立言",
    cast: [
      { name: "梁颂文", role: "饰 程朗", avatar: av[0] },
      { name: "苏敏", role: "饰 方怡", avatar: av[6] },
      { name: "何家豪", role: "饰 阿杰", avatar: av[10] },
    ],
    synopsis: "两个人坐在同一张桌子前整整一夜，谁先开口谁就输掉一切。",
    plot:
      "程朗与方怡曾是搭档，如今却因为一桩旧案坐在了谈判桌的两端。整整一夜，他们都心知肚明对方手里握着什么，也都在等对方先松口。沉默有时比语言更有力量，也更危险。",
    tags: ["对峙", "旧案", "博弈"],
    poster:
      "https://readdy.ai/api/search-image?query=two%20people%20in%20tense%20silence%20across%20a%20small%20table%2C%20cinematic%20film%20poster%20art%2C%20moody%20deep%20red%20and%20amber%20color%20palette%2C%20dramatic%20chiaroscuro%20lighting%2C%20subtle%20film%20grain%2C%20elegant%20negative%20space%20for%20title%2C%20emotional%20relationship%20drama%20mood%2C%20highly%20detailed%20vertical%20composition&width=600&height=900&seq=film-11-poster&orientation=portrait",
  },
  {
    id: "12",
    title: "空荡的房子",
    originalTitle: "The Empty House",
    year: 2009,
    genres: ["剧情", "心理"],
    region: "加拿大",
    duration: 94,
    rating: 6.9,
    director: "艾薇·汤普森",
    cast: [
      { name: "玛雅·洛佩兹", role: "饰 海伦", avatar: av[9] },
      { name: "卢卡斯·穆尔", role: "饰 丹尼尔", avatar: av[2] },
      { name: "佐伊·贝克", role: "饰 艾米", avatar: av[4] },
    ],
    synopsis: "孩子离家之后，一对夫妻开始重新学习如何面对彼此。",
    plot:
      "当最小的孩子也离家上大学，海伦和丹尼尔第一次真正独自面对这栋住了一辈子的房子。曾经的忙碌掩盖了太多问题，如今安静下来，所有被搁置的隔阂都无处可藏。他们要重新学会的，是如何与一个熟悉的陌生人相处。",
    tags: ["空巢", "婚姻", "重建"],
    poster:
      "https://readdy.ai/api/search-image?query=a%20vast%20empty%20house%20interior%20with%20one%20lit%20window%2C%20cinematic%20film%20poster%20art%2C%20moody%20deep%20red%20and%20amber%20color%20palette%2C%20dramatic%20chiaroscuro%20lighting%2C%20subtle%20film%20grain%2C%20elegant%20negative%20space%20for%20title%2C%20emotional%20relationship%20drama%20mood%2C%20highly%20detailed%20vertical%20composition&width=600&height=900&seq=film-12-poster&orientation=portrait",
  },
  {
    id: "13",
    title: "谁在说谎",
    originalTitle: "Who Is Lying",
    year: 2022,
    genres: ["悬疑", "惊悚", "心理"],
    region: "韩国",
    duration: 124,
    rating: 8.2,
    director: "郑在勋",
    cast: [
      { name: "申夏恩", role: "饰 智媛", avatar: av[7] },
      { name: "崔民赫", role: "饰 东贤", avatar: av[6] },
      { name: "尹素妍", role: "饰 娜京", avatar: av[5] },
    ],
    synopsis: "一起密室失踪案，三个当事人的口供彼此矛盾，真相只有一个。",
    plot:
      "一名女子在自家密室中离奇失踪，门窗完好，没有外人闯入的痕迹。警方锁定了三个人：她的丈夫、她的闺蜜和她的雇主。三份口供看似严丝合缝，却处处相互矛盾。当第四个版本浮出水面，所有人都成了嫌疑人。",
    tags: ["密室", "口供", "推理"],
    poster:
      "https://readdy.ai/api/search-image?query=a%20shadowy%20face%20half%20hidden%20in%20darkness%2C%20cinematic%20film%20poster%20art%2C%20moody%20deep%20red%20and%20amber%20color%20palette%2C%20dramatic%20chiaroscuro%20lighting%2C%20subtle%20film%20grain%2C%20elegant%20negative%20space%20for%20title%2C%20emotional%20relationship%20drama%20mood%2C%20highly%20detailed%20vertical%20composition&width=600&height=900&seq=film-13-poster&orientation=portrait",
  },
  {
    id: "14",
    title: "镜中的女人",
    originalTitle: "The Woman in the Mirror",
    year: 2010,
    genres: ["心理", "剧情"],
    region: "法国",
    duration: 100,
    rating: 7.3,
    director: "朱丽·贝尔纳",
    cast: [
      { name: "卡蜜尔·杜兰", role: "饰 伊莲", avatar: av[10] },
      { name: "马修·勒费", role: "饰 保罗", avatar: av[8] },
      { name: "诺拉·薇", role: "饰 苏菲", avatar: av[3] },
    ],
    synopsis: "一位舞台演员在角色与自我之间逐渐迷失，镜子成了唯一的见证者。",
    plot:
      "伊莲为了一个极具挑战的角色，开始长时间沉浸在人物的情绪与记忆里。随着排练深入，她越来越难分辨哪些感受属于角色，哪些属于自己。镜子里那张脸，究竟是谁，连她自己也开始动摇了。",
    tags: ["身份", "表演", "迷失"],
    poster:
      "https://readdy.ai/api/search-image?query=a%20woman%20in%20a%20mirror%20looking%20at%20her%20own%20reflection%2C%20cinematic%20film%20poster%20art%2C%20moody%20deep%20red%20and%20amber%20color%20palette%2C%20dramatic%20chiaroscuro%20lighting%2C%20subtle%20film%20grain%2C%20elegant%20negative%20space%20for%20title%2C%20emotional%20relationship%20drama%20mood%2C%20highly%20detailed%20vertical%20composition&width=600&height=900&seq=film-14-poster&orientation=portrait",
  },
  {
    id: "15",
    title: "昨日的信",
    originalTitle: "Letters From Yesterday",
    year: 2018,
    genres: ["爱情", "剧情"],
    region: "英国",
    duration: 107,
    rating: 7.9,
    director: "艾玛·格雷",
    cast: [
      { name: "奥利维亚·哈特", role: "饰 克莱尔", avatar: av[3] },
      { name: "艾德华·莱恩", role: "饰 汤姆", avatar: av[11] },
      { name: "伊莎贝尔·佩恩", role: "饰 露丝", avatar: av[6] },
    ],
    synopsis: "整理祖母遗物时，她发现了一沓从未寄出的情书，收信人不是祖父。",
    plot:
      "克莱尔在为祖母整理遗物时，意外发现了一沓被保存了半个多世纪的信。信里写满了炽热的思念，收信人却并非她的祖父。循着信上的地址，她踏上了一段寻找祖母年轻时秘密的旅程，也开始重新理解爱与选择。",
    tags: ["书信", "往事", "跨越时代"],
    poster:
      "https://readdy.ai/api/search-image?query=an%20old%20letter%20held%20under%20a%20warm%20desk%20lamp%2C%20cinematic%20film%20poster%20art%2C%20moody%20deep%20red%20and%20amber%20color%20palette%2C%20dramatic%20chiaroscuro%20lighting%2C%20subtle%20film%20grain%2C%20elegant%20negative%20space%20for%20title%2C%20emotional%20relationship%20drama%20mood%2C%20highly%20detailed%20vertical%20composition&width=600&height=900&seq=film-15-poster&orientation=portrait",
  },
  {
    id: "16",
    title: "背叛的花园",
    originalTitle: "Garden of Betrayal",
    year: 2016,
    genres: ["剧情", "爱情"],
    region: "意大利",
    duration: 118,
    rating: 7.6,
    director: "卢卡·费拉里",
    cast: [
      { name: "艾莲娜·罗西", role: "饰 朱莉娅", avatar: av[9] },
      { name: "乔治·孔蒂", role: "饰 里奥", avatar: av[8] },
      { name: "索菲亚·兰", role: "饰 玛尔塔", avatar: av[2] },
    ],
    synopsis: "一座传承三代的庄园花园，见证了一个家族最深的爱与最痛的背叛。",
    plot:
      "朱莉娅继承了祖辈留下的庄园花园，也继承了一个从没人愿意提起的家族秘密。当远房亲戚里奥回到庄园，尘封多年的往事重新被翻开。花香之下，是几代人纠缠不清的爱与背叛。",
    tags: ["庄园", "家族", "背叛"],
    poster:
      "https://readdy.ai/api/search-image?query=a%20rose%20petal%20falling%20in%20a%20dim%20garden%20at%20dusk%2C%20cinematic%20film%20poster%20art%2C%20moody%20deep%20red%20and%20amber%20color%20palette%2C%20dramatic%20chiaroscuro%20lighting%2C%20subtle%20film%20grain%2C%20elegant%20negative%20space%20for%20title%2C%20emotional%20relationship%20drama%20mood%2C%20highly%20detailed%20vertical%20composition&width=600&height=900&seq=film-16-poster&orientation=portrait",
  },
  {
    id: "17",
    title: "夜晚的访客",
    originalTitle: "The Night Visitor",
    year: 2023,
    genres: ["悬疑", "惊悚"],
    region: "美国",
    duration: 105,
    rating: 7.7,
    director: "瑞恩·科尔",
    cast: [
      { name: "娜塔莉·格林", role: "饰 蕾切尔", avatar: av[3] },
      { name: "彼得·霍尔", role: "饰 亚伦", avatar: av[10] },
      { name: "詹姆斯·里德", role: "饰 山姆", avatar: av[2] },
    ],
    synopsis: "暴风雨夜的敲门声，让一个独居女子的生活从此天翻地覆。",
    plot:
      "独居的蕾切尔在一个暴风雨夜听到有人敲门，门外站着一个浑身湿透的陌生男人。他说自己的车抛锚了，只是想借电话。出于同情，她让他进了门。这个决定，让她卷入了一场蓄谋已久的复仇之中。",
    tags: ["暴风雨", "陌生人", "复仇"],
    poster:
      "https://readdy.ai/api/search-image?query=a%20mysterious%20figure%20at%20a%20doorway%20during%20a%20thunderstorm%2C%20cinematic%20film%20poster%20art%2C%20moody%20deep%20red%20and%20amber%20color%20palette%2C%20dramatic%20chiaroscuro%20lighting%2C%20subtle%20film%20grain%2C%20elegant%20negative%20space%20for%20title%2C%20emotional%20relationship%20drama%20mood%2C%20highly%20detailed%20vertical%20composition&width=600&height=900&seq=film-17-poster&orientation=portrait",
  },
  {
    id: "18",
    title: "两个夏天",
    originalTitle: "Two Summers",
    year: 2014,
    genres: ["爱情", "剧情"],
    region: "日本",
    duration: 99,
    rating: 7.4,
    director: "中村知也",
    cast: [
      { name: "小林遥", role: "饰 夏帆", avatar: av[6] },
      { name: "高桥凉介", role: "饰 亮太", avatar: av[9] },
      { name: "森川葵", role: "饰 美月", avatar: av[11] },
    ],
    synopsis: "同一个夏天，两个不同的选择，通向了两段截然不同的人生。",
    plot:
      "夏帆站在人生关口，做出选择的那一天恰好与她记忆里最重要的夏天重逢。影片以平行叙事呈现两种选择下的人生：一个夏天她在小城守着家人，另一个夏天她远走他乡追逐梦想。两条路上，她都遇见了爱，也都被爱改变。",
    tags: ["夏天", "抉择", "平行叙事"],
    poster:
      "https://readdy.ai/api/search-image?query=two%20sisters%20standing%20in%20golden%20summer%20light%2C%20cinematic%20film%20poster%20art%2C%20moody%20deep%20red%20and%20amber%20color%20palette%2C%20dramatic%20chiaroscuro%20lighting%2C%20subtle%20film%20grain%2C%20elegant%20negative%20space%20for%20title%2C%20emotional%20relationship%20drama%20mood%2C%20highly%20detailed%20vertical%20composition&width=600&height=900&seq=film-18-poster&orientation=portrait",
  },
  {
    id: "19",
    title: "消失的戒指",
    originalTitle: "The Vanished Ring",
    year: 2012,
    genres: ["悬疑", "剧情"],
    region: "中国香港",
    duration: 103,
    rating: 7.2,
    director: "陈立言",
    cast: [
      { name: "苏敏", role: "饰 若彤", avatar: av[6] },
      { name: "梁颂文", role: "饰 家俊", avatar: av[0] },
      { name: "何家豪", role: "饰 老周", avatar: av[10] },
    ],
    synopsis: "订婚戒指在婚礼前夜不翼而飞，找戒指的过程揭开了一个家族的裂痕。",
    plot:
      "婚礼前夜，若彤发现自己珍藏的订婚戒指不见了。在翻找的过程中，她无意间翻出了一连串家人不愿提及的旧事。戒指究竟被谁拿走并不重要，重要的是它照出了这个家早就存在的裂缝。",
    tags: ["婚礼", "家族", "裂痕"],
    poster:
      "https://readdy.ai/api/search-image?query=a%20missing%20ring%20on%20an%20empty%20dresser%2C%20cinematic%20film%20poster%20art%2C%20moody%20deep%20red%20and%20amber%20color%20palette%2C%20dramatic%20chiaroscuro%20lighting%2C%20subtle%20film%20grain%2C%20elegant%20negative%20space%20for%20title%2C%20emotional%20relationship%20drama%20mood%2C%20highly%20detailed%20vertical%20composition&width=600&height=900&seq=film-19-poster&orientation=portrait",
  },
  {
    id: "20",
    title: "红酒与谎言",
    originalTitle: "Red Wine and Lies",
    year: 2017,
    genres: ["剧情", "爱情"],
    region: "西班牙",
    duration: 108,
    rating: 7.5,
    director: "卡洛斯·梅纳",
    cast: [
      { name: "伊莎贝尔·诺", role: "饰 露西亚", avatar: av[2] },
      { name: "哈维尔·奥尔特加", role: "饰 迭戈", avatar: av[4] },
      { name: "玛尔塔·桑斯", role: "饰 卡门", avatar: av[5] },
    ],
    synopsis: "一场品酒会，让三个早已疏远的老友不得不重提当年的那件事。",
    plot:
      "因一桩意外而疏远多年的三位老友，因一场品酒会重新聚首。酒精是最好的放松剂，也是最诚实的证人。当话题绕回到那一年发生的事，每个人口中的版本都不一样，而真相恰恰藏在最多的那杯酒里。",
    tags: ["重逢", "往事", "真相"],
    poster:
      "https://readdy.ai/api/search-image?query=two%20wine%20glasses%20on%20a%20dim%20romantic%20table%2C%20cinematic%20film%20poster%20art%2C%20moody%20deep%20red%20and%20amber%20color%20palette%2C%20dramatic%20chiaroscuro%20lighting%2C%20subtle%20film%20grain%2C%20elegant%20negative%20space%20for%20title%2C%20emotional%20relationship%20drama%20mood%2C%20highly%20detailed%20vertical%20composition&width=600&height=900&seq=film-20-poster&orientation=portrait",
  },
  {
    id: "21",
    title: "陌生的枕边人",
    originalTitle: "The Stranger Beside Me",
    year: 2020,
    genres: ["悬疑", "心理"],
    region: "英国",
    duration: 116,
    rating: 8.0,
    director: "艾玛·格雷",
    cast: [
      { name: "苏菲·唐", role: "饰 艾米", avatar: av[7] },
      { name: "亨利·邦德", role: "饰 杰克", avatar: av[2] },
      { name: "奥利维亚·哈特", role: "饰 黛安", avatar: av[3] },
    ],
    synopsis: "车祸后的丈夫性情大变，妻子开始怀疑，醒来的人到底还是不是他。",
    plot:
      "杰克在一场车祸后奇迹般苏醒，却像换了一个人。他记不起很多旧事，却知道一些不该知道的细节。艾米一边照顾他，一边在生活里发现了越来越多不合理之处。她必须弄清，枕边这个熟悉又陌生的人，究竟是谁。",
    tags: ["失忆", "身份", "疑心"],
    poster:
      "https://readdy.ai/api/search-image?query=a%20stranger%20sleeping%20beside%20an%20unknown%20person%2C%20cinematic%20film%20poster%20art%2C%20moody%20deep%20red%20and%20amber%20color%20palette%2C%20dramatic%20chiaroscuro%20lighting%2C%20subtle%20film%20grain%2C%20elegant%20negative%20space%20for%20title%2C%20emotional%20relationship%20drama%20mood%2C%20highly%20detailed%20vertical%20composition&width=600&height=900&seq=film-21-poster&orientation=portrait",
  },
  {
    id: "22",
    title: "雨夜的电话",
    originalTitle: "A Call in the Rain",
    year: 2013,
    genres: ["剧情", "惊悚"],
    region: "韩国",
    duration: 97,
    rating: 7.1,
    director: "朴承佑",
    cast: [
      { name: "韩智秀", role: "饰 秀珍", avatar: av[5] },
      { name: "金泰成", role: "饰 宰赫", avatar: av[6] },
      { name: "李恩珠", role: "饰 恩彩", avatar: av[7] },
    ],
    synopsis: "一个深夜打错的电话，让两个素不相识的人卷入同一场危险。",
    plot:
      "秀珍在一个雨夜接到了一通关错号码的电话，对面的人在求救。她本能地想挂断，却又放心不下。顺着那唯一的声音线索，她一步步走进了一个陌生人的困境，也逼近了自己最不愿面对的往事。",
    tags: ["夜晚", "求救", "牵连"],
    poster:
      "https://readdy.ai/api/search-image?query=a%20phone%20ringing%20on%20a%20rainy%20night%20windowsill%2C%20cinematic%20film%20poster%20art%2C%20moody%20deep%20red%20and%20amber%20color%20palette%2C%20dramatic%20chiaroscuro%20lighting%2C%20subtle%20film%20grain%2C%20elegant%20negative%20space%20for%20title%2C%20emotional%20relationship%20drama%20mood%2C%20highly%20detailed%20vertical%20composition&width=600&height=900&seq=film-22-poster&orientation=portrait",
  },
  {
    id: "23",
    title: "最后一支舞",
    originalTitle: "The Last Dance",
    year: 2015,
    genres: ["爱情", "剧情"],
    region: "法国",
    duration: 112,
    rating: 7.8,
    director: "克莱尔·德邦",
    cast: [
      { name: "露西·莫罗", role: "饰 艾玛", avatar: av[2] },
      { name: "安托万·贝尔", role: "饰 卢卡", avatar: av[4] },
      { name: "玛戈·肖", role: "饰 莲娜", avatar: av[11] },
    ],
    synopsis: "一位退休舞者，用最后一支舞向自己最爱的人和最遗憾的往事告别。",
    plot:
      "年过六旬的舞者艾玛收到一封邀请，希望她在旧剧院的告别演出上再跳一支舞。那支舞承载着她与一位搭档未完成的故事。当她重新站上舞台，跳的不仅是一支舞，更是一段被时间封存的告别。",
    tags: ["舞蹈", "告别", "回忆"],
    poster:
      "https://readdy.ai/api/search-image?query=a%20couple%20dancing%20in%20an%20empty%20ballroom%2C%20cinematic%20film%20poster%20art%2C%20moody%20deep%20red%20and%20amber%20color%20palette%2C%20dramatic%20chiaroscuro%20lighting%2C%20subtle%20film%20grain%2C%20elegant%20negative%20space%20for%20title%2C%20emotional%20relationship%20drama%20mood%2C%20highly%20detailed%20vertical%20composition&width=600&height=900&seq=film-23-poster&orientation=portrait",
  },
  {
    id: "24",
    title: "归来的陌生人",
    originalTitle: "The Returning Stranger",
    year: 2019,
    genres: ["剧情", "悬疑"],
    region: "德国",
    duration: 121,
    rating: 7.7,
    director: "汉娜·克劳斯",
    cast: [
      { name: "托马斯·韦伯", role: "饰 米夏埃尔", avatar: av[8] },
      { name: "莉娜·冯", role: "饰 玛尔塔", avatar: av[5] },
      { name: "安娜·舒尔茨", role: "饰 汉娜", avatar: av[11] },
    ],
    synopsis: "失踪二十年的父亲突然回家，可家人早已学会了没有他的生活。",
    plot:
      "失踪二十年的父亲米夏埃尔毫无征兆地回到了家。母亲玛尔塔和女儿汉娜早已用二十年的时间，学会了如何把这个人从生活里抹去。他的归来没有带来团圆，反而让这个重新缝合的家再一次被撕开。",
    tags: ["归来", "家庭", "陌生"],
    poster:
      "https://readdy.ai/api/search-image?query=a%20man%20returning%20home%20to%20a%20familiar%20door%2C%20cinematic%20film%20poster%20art%2C%20moody%20deep%20red%20and%20amber%20color%20palette%2C%20dramatic%20chiaroscuro%20lighting%2C%20subtle%20film%20grain%2C%20elegant%20negative%20space%20for%20title%2C%20emotional%20relationship%20drama%20mood%2C%20highly%20detailed%20vertical%20composition&width=600&height=900&seq=film-24-poster&orientation=portrait",
  },
  {
    id: "25",
    title: "交换游戏",
    originalTitle: "The Swap Game",
    year: 2021,
    genres: ["悬疑", "剧情", "惊悚"],
    region: "美国",
    duration: 113,
    rating: 7.6,
    director: "马克·罗兰",
    cast: [
      { name: "大卫·威尔逊", role: "饰 内森", avatar: av[0] },
      { name: "艾米莉·卡特", role: "饰 格蕾丝", avatar: av[1] },
      { name: "索菲亚·罗曼", role: "饰 薇薇安", avatar: av[3] },
    ],
    synopsis: "四个朋友玩起一场身份交换的游戏，规则很简单，代价却难以承受。",
    plot:
      "四个多年好友为了给平淡的生活找点刺激，玩起了一场身份交换的游戏：每个人在限定时间内扮演另一个人。起初只是玩笑，可当秘密被一件件揭开，游戏渐渐失控，再也没有人愿意做回原来的自己。",
    tags: ["游戏", "身份", "失控"],
    poster:
      "https://readdy.ai/api/search-image?query=four%20friends%20playing%20a%20dangerous%20game%20around%20a%20table%2C%20cinematic%20film%20poster%20art%2C%20moody%20deep%20red%20and%20amber%20color%20palette%2C%20dramatic%20chiaroscuro%20lighting%2C%20subtle%20film%20grain%2C%20elegant%20negative%20space%20for%20title%2C%20emotional%20relationship%20drama%20mood%2C%20highly%20detailed%20vertical%20composition&width=600&height=900&seq=film-25-poster&orientation=portrait",
  },
  {
    id: "26",
    title: "半张照片",
    originalTitle: "Half a Photograph",
    year: 2010,
    genres: ["剧情", "悬疑"],
    region: "中国香港",
    duration: 95,
    rating: 7.0,
    director: "陈立言",
    cast: [
      { name: "梁颂文", role: "饰 阿Ken", avatar: av[0] },
      { name: "苏敏", role: "饰 阿雪", avatar: av[6] },
      { name: "何家豪", role: "饰 强叔", avatar: av[10] },
    ],
    synopsis: "一张被撕掉一半的旧照片，牵出一段被刻意遗忘的青春。",
    plot:
      "阿Ken在搬家时翻出一张只有半边的旧照片，照片上的人他一个都认不出来，却莫名觉得眼熟。为了找出照片的另一半，他走访了老街区里仅剩的几位老邻居，也重新拾起了一段被自己刻意封存的青春往事。",
    tags: ["旧照", "青春", "记忆"],
    poster:
      "https://readdy.ai/api/search-image?query=a%20torn%20photograph%20held%20in%20one%20hand%2C%20cinematic%20film%20poster%20art%2C%20moody%20deep%20red%20and%20amber%20color%20palette%2C%20dramatic%20chiaroscuro%20lighting%2C%20subtle%20film%20grain%2C%20elegant%20negative%20space%20for%20title%2C%20emotional%20relationship%20drama%20mood%2C%20highly%20detailed%20vertical%20composition&width=600&height=900&seq=film-26-poster&orientation=portrait",
  },
  {
    id: "27",
    title: "记忆的裂缝",
    originalTitle: "Cracks of Memory",
    year: 2022,
    genres: ["心理", "悬疑", "剧情"],
    region: "韩国",
    duration: 126,
    rating: 8.1,
    director: "郑在勋",
    cast: [
      { name: "申夏恩", role: "饰 秀雅", avatar: av[7] },
      { name: "崔民赫", role: "饰 泰宇", avatar: av[6] },
      { name: "尹素妍", role: "饰 智恩", avatar: av[5] },
    ],
    synopsis: "一位记忆科学家在研究自己的病例时，发现被她篡改的正是自己的过去。",
    plot:
      "秀雅是一位研究记忆修复的科学家，致力于帮助病人重建破碎的回忆。直到她开始研究一份匿名病例，才惊觉那些被技术处理过的记忆，正是她自己试图遗忘的过去。当记忆可以被编辑，我们还能相信哪一个自己。",
    tags: ["记忆", "科技", "自我"],
    poster:
      "https://readdy.ai/api/search-image?query=a%20fractured%20memory%20scene%20with%20overlapping%20faces%2C%20cinematic%20film%20poster%20art%2C%20moody%20deep%20red%20and%20amber%20color%20palette%2C%20dramatic%20chiaroscuro%20lighting%2C%20subtle%20film%20grain%2C%20elegant%20negative%20space%20for%20title%2C%20emotional%20relationship%20drama%20mood%2C%20highly%20detailed%20vertical%20composition&width=600&height=900&seq=film-27-poster&orientation=portrait",
  },
  {
    id: "28",
    title: "无名之信",
    originalTitle: "The Unsigned Letter",
    year: 2016,
    genres: ["剧情", "爱情"],
    region: "英国",
    duration: 102,
    rating: 7.3,
    director: "艾玛·格雷",
    cast: [
      { name: "伊莎贝尔·佩恩", role: "饰 罗莎", avatar: av[6] },
      { name: "艾德华·莱恩", role: "饰 亨利", avatar: av[11] },
      { name: "奥利维亚·哈特", role: "饰 玛格丽特", avatar: av[3] },
    ],
    synopsis: "一封没有署名的信，在两个人之间传递了一整个冬天。",
    plot:
      "战后的伦敦，罗莎在旧书里发现了一封没有署名的信。出于好奇，她按信里的地址回了信，从此开始了一段只靠纸笔维系的往来。整整一个冬天，他们交换着生活的碎片，却始终没有见过面，也没有说出名字。",
    tags: ["书信", "往来", "相见"],
    poster:
      "https://readdy.ai/api/search-image?query=an%20unsigned%20letter%20on%20a%20dark%20table%2C%20cinematic%20film%20poster%20art%2C%20moody%20deep%20red%20and%20amber%20color%20palette%2C%20dramatic%20chiaroscuro%20lighting%2C%20subtle%20film%20grain%2C%20elegant%20negative%20space%20for%20title%2C%20emotional%20relationship%20drama%20mood%2C%20highly%20detailed%20vertical%20composition&width=600&height=900&seq=film-28-poster&orientation=portrait",
  },
  {
    id: "29",
    title: "远处的灯塔",
    originalTitle: "The Distant Lighthouse",
    year: 2011,
    genres: ["剧情"],
    region: "意大利",
    duration: 111,
    rating: 7.4,
    director: "卢卡·费拉里",
    cast: [
      { name: "尼科·布鲁诺", role: "饰 安德烈", avatar: av[10] },
      { name: "艾莲娜·罗西", role: "饰 卡特琳娜", avatar: av[9] },
      { name: "索菲亚·兰", role: "饰 露琪亚", avatar: av[2] },
    ],
    synopsis: "守塔人用二十年的孤独，等一个再也不会回来的约定。",
    plot:
      "安德烈独自守着海边的一座灯塔，日复一日地记录着潮汐与来往的船只。岛上的人都以为他只是习惯了孤独，只有他自己知道，他是在等一个人。二十年前的那个约定，他始终没有忘记。",
    tags: ["灯塔", "守候", "孤独"],
    poster:
      "https://readdy.ai/api/search-image?query=a%20distant%20lighthouse%20shining%20over%20a%20dark%20sea%2C%20cinematic%20film%20poster%20art%2C%20moody%20deep%20red%20and%20amber%20color%20palette%2C%20dramatic%20chiaroscuro%20lighting%2C%20subtle%20film%20grain%2C%20elegant%20negative%20space%20for%20title%2C%20emotional%20relationship%20drama%20mood%2C%20highly%20detailed%20vertical%20composition&width=600&height=900&seq=film-29-poster&orientation=portrait",
  },
  {
    id: "30",
    title: "重逢的代价",
    originalTitle: "The Price of Reunion",
    year: 2024,
    genres: ["剧情", "爱情", "悬疑"],
    region: "中国大陆",
    duration: 119,
    rating: 8.3,
    director: "沈亦舟",
    cast: [
      { name: "林之遥", role: "饰 沈知微", avatar: av[9] },
      { name: "陆沉", role: "饰 顾言", avatar: av[8] },
      { name: "徐清", role: "饰 周程", avatar: av[0] },
    ],
    synopsis: "十年后的一场重逢，揭开的却是一段被双方共同隐瞒的真相。",
    plot:
      "沈知微和顾言在分别十年后于一场同学聚会重逢。两人都以为时间已经抹平了过去，可几杯酒下肚，那些被刻意回避的话题还是浮了上来。他们这才发现，当年分开的原因，两个人都只说出了一半的真相。",
    tags: ["重逢", "真相", "十年"],
    poster:
      "https://readdy.ai/api/search-image?query=two%20former%20lovers%20meeting%20again%20in%20the%20rain%2C%20cinematic%20film%20poster%20art%2C%20moody%20deep%20red%20and%20amber%20color%20palette%2C%20dramatic%20chiaroscuro%20lighting%2C%20subtle%20film%20grain%2C%20elegant%20negative%20space%20for%20title%2C%20emotional%20relationship%20drama%20mood%2C%20highly%20detailed%20vertical%20composition&width=600&height=900&seq=film-30-poster&orientation=portrait",
  },
];

export const genreOptions = ["剧情", "爱情", "悬疑", "惊悚", "心理", "家庭"];
export const regionOptions = ["美国", "英国", "法国", "意大利", "德国", "西班牙", "韩国", "日本", "中国香港", "中国大陆", "加拿大"];
export const decadeOptions = ["2020年代", "2010年代", "2000年代"];